import { Link } from 'react-router-dom';

const categories = [
  {
    slug: 'wanghong-baoliao',
    name: '网红爆料',
    description: '各平台网红最新黑料、翻车事件、人设崩塌全纪录',
    icon: 'ri-spy-line',
    count: 1256,
    color: 'from-primary-500/85 to-primary-700/85',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20tone%20entertainment%20news%20category%20background%20for%20internet%20celebrity%20expose%2C%20Chinese%20social%20media%20gossip%20theme%2C%20artistic%20editorial%20style%20with%20soft%20gradients%20in%20warm%20crimson%20tones%2C%20subtle%20digital%20elements%2C%20modern%20clean%20composition&width=600&height=450&seq=cat-wanghong&orientation=landscape',
  },
  {
    slug: 'mingxing-heitiao',
    name: '明星黑料',
    description: '娱乐圈明星最新八卦、绯闻、争议事件追踪报道',
    icon: 'ri-star-smile-line',
    count: 983,
    color: 'from-accent-500/85 to-accent-700/85',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20tone%20entertainment%20news%20category%20for%20celebrity%20gossip%2C%20Chinese%20social%20media%20theme%2C%20artistic%20editorial%20style%20with%20soft%20gradients%20in%20warm%20amber%20tones%2C%20subtle%20digital%20elements%2C%20modern%20composition&width=600&height=450&seq=cat-mingxing&orientation=landscape',
  },
  {
    slug: 'remen-zhuizong',
    name: '热门追踪',
    description: '全网最热门吃瓜事件实时追踪与深度分析',
    icon: 'ri-fire-line',
    count: 2145,
    color: 'from-primary-600/85 to-primary-800/85',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20tone%20trending%20news%20tracking%20background%2C%20Chinese%20social%20media%20gossip%20theme%2C%20artistic%20editorial%20style%20with%20soft%20gradients%20in%20warm%20red%20tones%2C%20dynamic%20subtle%20elements%2C%20modern%20clean%20composition&width=600&height=450&seq=cat-remen&orientation=landscape',
  },
  {
    slug: 'chigua-shipin',
    name: '吃瓜视频',
    description: '每日最新吃瓜视频、爆料直播、热门片段合集',
    icon: 'ri-vidicon-line',
    count: 1567,
    color: 'from-accent-600/85 to-accent-800/85',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20tone%20video%20entertainment%20category%20background%2C%20Chinese%20social%20media%20theme%2C%20artistic%20editorial%20style%20with%20soft%20gradients%20in%20warm%20golden%20amber%20tones%2C%20subtle%20play%20elements%2C%20modern%20composition&width=600&height=450&seq=cat-shipin&orientation=landscape',
  },
  {
    slug: 'yule-quan',
    name: '娱乐圈',
    description: '影视圈、音乐圈、综艺圈全方位娱乐资讯',
    icon: 'ri-movie-line',
    count: 1872,
    color: 'from-secondary-500/85 to-secondary-700/85',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20tone%20entertainment%20industry%20category%20background%2C%20Chinese%20media%20theme%2C%20artistic%20editorial%20style%20with%20soft%20gradients%20in%20warm%20neutral%20tones%2C%20subtle%20film%20elements%2C%20modern%20composition&width=600&height=450&seq=cat-yule&orientation=landscape',
  },
  {
    slug: 'zhibo-quan',
    name: '直播圈',
    description: '各大直播平台主播动态、PK恩怨、带货内幕揭秘',
    icon: 'ri-live-line',
    count: 845,
    color: 'from-primary-500/85 to-accent-500/85',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20tone%20livestream%20industry%20category%20background%2C%20Chinese%20social%20media%20theme%2C%20artistic%20editorial%20style%20with%20soft%20gradients%20in%20warm%20red%20and%20amber%20tones%2C%20digital%20broadcast%20elements%2C%20modern%20composition&width=600&height=450&seq=cat-zhibo&orientation=landscape',
  },
];

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            分类深扒
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            按分类浏览，精准定位你想吃的每一口瓜
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative rounded-2xl overflow-hidden aspect-[4/3] cursor-pointer"
            >
              <img
                src={cat.imageUrl}
                alt={cat.name}
                title={`${cat.name} - 91在线吃瓜`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className={`absolute inset-0 bg-gradient-to-br ${cat.color}`}></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-6">
                <div className="w-14 h-14 flex items-center justify-center mb-3">
                  <i className={`${cat.icon} text-3xl text-background-50`}></i>
                </div>
                <h3 className="text-xl font-heading font-bold text-background-50 mb-1">
                  {cat.name}
                </h3>
                <p className="text-xs text-background-50/80 mb-3 line-clamp-2">
                  {cat.description}
                </p>
                <span className="text-[10px] px-3 py-1 rounded-full bg-background-50/20 text-background-50 font-medium">
                  {cat.count.toLocaleString()} 条爆料
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}